import { gql } from '@apollo/client';

export const GET_SHOCKED_IMPACT = gql`
  query ShockImpactQuery($portfolioId: String!, $asOfDate: String!, $skip: Int, $take: Int, $positionIds: [String!]) {
    positions(portfolioId: $portfolioId, skip: $skip, take: $take, asOfDate: $asOfDate, disposedRemoved: false) {
      positionId
      fAS115
      currFace
      bookValue
      isDeleted
      disposedDate
    }
    positionRateShiftResults(skip: $skip, take: $take, positionIds: $positionIds) {
      positionId
      marketPrice0
      marketPrice2
      marketPrice4
      marketPrice6
      marketPrice8
    }
    asOfDates(portfolioId: $portfolioId, take: $take, skip: $skip) {
      totalTier1Capital
      totalCapital
      totalAssets
      totalRiskBasedAssets
      taxesFedRate
      taxesStateRate
    }
  }
`;
